import { client } from "api";

export type RemoveExternalUserRequest = { userId: string; orderId: string };
export type RemoveExternalUserResponse = string;

export const removeExternalUser = (params: RemoveExternalUserRequest) =>
  client.post<RemoveExternalUserResponse>(`/order/assign`, params).then((res) => res.data);
